<template>
    <div id="cookie-content" class="accept-cookie" v-if="cookieNotAvailable">
        <v-container class="no-padding-left no-margin-left">
            <v-layout row wrap>
                <v-flex md10 sm9 xs12 class="accept-cookie-text-wrapper">
                    <div>
                <span>{{text('api.cookie.acceptance.text')}}</span>
                        <a v-if="isDocProperty" @click="aboutCookies"> {{text('api.cookie.acceptance.link')}}</a>
                    </div>
                </v-flex>
                <v-flex md2 sm3 xs12>
                    <v-btn class="color-on-primary-text" color="primary" @click="acceptCookies">{{text('api.cookie.acceptance.button')}}</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>



    import {mapGetters} from "vuex";

    export default {
        name: "accept-cookie",

        data() {
            return {
                cookieNotAvailable : true,
            }
        },

        computed: {
            ...mapGetters({
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getDocApplicationType: 'TranslationStore/getDocApplicationType'
            }),

            isDocProperty() {
                const applicationType = this.getDocApplicationType();

                return this.getAppPropertyValue("DOC_" + applicationType + "_ADDRESS_" + 3) !== null;
            },
        },

        methods :{
            acceptCookies () {

                /* SET COOKIE FOR ACCEPTANCE */
                function setCookie(name,value, days) {
                   let expires = "";
                    if (days) {
                        let date = new Date();
                        date.setTime(date.getTime() + (days*24*60*60*1000));
                        expires = "; expires=" + date.toUTCString();
                    }
                    document.cookie = name + "=" + (value || "")   + expires + "; path=/";
                }

                setCookie('smass-cookie', true, 366);
                this.cookieNotAvailable = false;

                let cookieInfo = document.getElementById('cookie-content');
                cookieInfo.style.display= "none";

            },
            aboutCookies () {
                this.$router.push({name: 'DocPage', query: {type: 3}});
            }
        },

        mounted () {
            let cookieInfo = document.getElementById('cookie-content');
            let code = (function () {
                return {
                    getCookie: function (name) {
                        let value = "; " + document.cookie;
                        let parts = value.split("; " + name + "=");
                        if (parts.length === 2) {
                            return parts.pop().split(";").shift();
                        }
                    }
                }
            })();

            // if the App Property is set to true then don't show the AcceptCookie
            let mustShowAcceptCookieConfirm = this.getAppPropertyValue('DISABLE_DISRUPTOR_COOKIE') === "true" ? false : true

            if(!code.getCookie('smass-cookie') && mustShowAcceptCookieConfirm) {
                setTimeout(function(){
                    //test.classList.add("accept-cookie")
                    cookieInfo.style.display= "block";
                    cookieInfo.style.height = "auto";
                    cookieInfo.style.position= "relative";
                }, 1000)
            }

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/professional/components/cookies/AcceptCookie.vue